import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer from './reducer/snackbarSlice';
import authUserReducer from './reducer/authUserSlice';
import drawerReducer from './reducer/drawerSlice';
import dialogReducer from './reducer/dialogSlice';
import modalReducer from './reducer/modalSlice'
import permissionReducers from './reducer/permissionSlice';
import sortingReducer from "./reducer/sortingSlice";
import tableSearchReducer from "./reducer/tableSearchSlice";
import showFiltersReducer from "./reducer/showFiltersSlice";
import LanguageReducer from "./reducer/languageSlice";
import LocationReducer from "./reducer/locationSlice";
import refreshReducer from "./reducer/refreshSlice";
import dateRangeReducer from "./reducer/dateRangeSlice";
import hospitalSelectionReducer from "./reducer/hospitalSelectionSlice";
import { ISLive } from '../utils/base-urls';

const store = configureStore({
    reducer: {
        snackbar: snackbarReducer,
        authUser: authUserReducer,
        drawer: drawerReducer,
        dialog: dialogReducer,
        modal: modalReducer,
        permission: permissionReducers,
        sorting: sortingReducer,
        tableSearch: tableSearchReducer,
        showFilters: showFiltersReducer,
        language: LanguageReducer,
        location: LocationReducer,
        refresh: refreshReducer,
        dateRange: dateRangeReducer,
        hospitalSelection: hospitalSelectionReducer,
    },

    devTools: !ISLive,
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof import('./store').default.getState>

export default store;